import { render, staticRenderFns } from "./footPrintingDetail.vue?vue&type=template&id=679d2713&scoped=true&"
import script from "./footPrintingDetail.vue?vue&type=script&lang=js&"
export * from "./footPrintingDetail.vue?vue&type=script&lang=js&"
import style0 from "./footPrintingDetail.vue?vue&type=style&index=0&id=679d2713&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "679d2713",
  null
  
)

export default component.exports